module.exports = __webpack_public_path__ + "static/media/41.b5070dbc.jpg";